import type {
  ScheduleViewFilters,
  ScheduleViewFiltersAction,
} from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFilters.ts";
import {
  ScheduleViewFiltersContext,
  ScheduleViewFiltersDispatchContext,
} from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFiltersProvider.tsx";
import type { Dispatch } from "react";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";

export default function useScheduleViewFilters(): {
  state: ScheduleViewFilters;
  dispatch: Dispatch<ScheduleViewFiltersAction>;
  callback: (a: ScheduleViewFiltersAction) => () => void;
} {
  const state = useDefinedContextValue(ScheduleViewFiltersContext);
  const dispatch = useDefinedContextValue(ScheduleViewFiltersDispatchContext);
  return {
    state,
    dispatch,
    callback:
      (a: ScheduleViewFiltersAction): (() => void) =>
      () => {
        dispatch(a);
      },
  };
}
